export const STRIPE_RESPONSE_DELAY = 2000;
